import { useContext } from 'react';

import { OpenSearchContext } from '../context';

const useOpenSearchContext = () => {
  const context = useContext(OpenSearchContext);

  if (!context)
    throw new Error(
      'useOpenSearchContext should be used within an OpenSearchProvider',
    );

  return context;
};

export { useOpenSearchContext };
